<template>
  <div>
    <div class="xgallery-container">
      <div class="xgallery-slider">
        <img id="xgalleryImage" src="" />
      </div>
      <div class="xdots-container" id="xdotsContainer"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['imgs'],
  data () {
    return {
      images: [],
      // images: [
      //   'https://camo.githubusercontent.com/5e45bc648dba68520ce949a53690af6bcef2880f84a1d46cbb1636649afd6d84/68747470733a2f2f796176757a63656c696b65722e6769746875622e696f2f73616d706c652d696d616765732f696d6167652d313032312e6a7067',
      //   'https://www.tboholidays.com//imageresource.aspx?img=FbrGPTrju5e/HYusSxssYNGz+r+daGo8+nI8f2/HFw9QwX+47gOd8n0vhhPU+r1viHuQFAGuk26sRSkquGjEA+1J8JVjr0GZpQ8Jf1oo+eEYx6RaIK0chQmK4vx5/HSCrMmNrlEvonaCdbOnpRrYEbRiAw5pC+uxnVsQvlSdaRgwD/1Au1zXew==',
      //   'https://www.tboholidays.com//imageresource.aspx?img=FbrGPTrju5e/HYusSxssYNGz+r+daGo8+nI8f2/HFw9QwX+47gOd8n0vhhPU+r1vUULEGWZvk66XKXiGrko/yP+/QNdinwsrDH2iO6EtGo5R0LgJH4b6OILu/2Md2KaRFDekYcqKEkyOxb81Ww1j1bAVz3qiRU6cL8qOXt3sQSTgubSAYELnLw=='
      // ],
      currentIndex: 0,
      autoPlayInterval: ''
    }
  },
  methods: {
    createDots () {
      let self = this
      if (!self.images.length) return
      let dotsContainer = document.getElementById('xdotsContainer')
      dotsContainer.innerHTML = '' // Clear existing dots
      self.images.forEach((_, index) => {
        const dot = document.createElement('span')
        dot.classList.add('xdot')
        if (index === 0) dot.classList.add('active')
        dot.dataset.index = index
        dot.addEventListener('click', () => self.goToSlide(index))
        dotsContainer.appendChild(dot)
      })
    },
    updateDots () {
      let self = this
      let dots = document.querySelectorAll('.xdot')
      dots.forEach((dot, index) => {
        dot.classList.toggle('active', index === self.currentIndex)
      })
    },
    changeSlide (direction) {
      this.currentIndex = (this.currentIndex + direction + this.images.length) % this.images.length
      this.updateSlide()
    },
    goToSlide (index) {
      if (index < 0 || index >= this.images.length) return
      this.currentIndex = index
      this.updateSlide()
    },
    updateSlide () {
      let self = this
      if (!self.images.length) return
      let galleryImage = document.getElementById('xgalleryImage')
      // Fade effect
      galleryImage.style.opacity = '0'
      setTimeout(() => {
        galleryImage.src = self.images[self.currentIndex]
        // galleryImage.alt = self.images[currentIndex].alt
        galleryImage.style.opacity = '1'
        self.updateDots()
      }, 300)
    },
    startAutoPlay () {
      let self = this
      if (!self.images.length) return
      this.autoPlayInterval = setInterval(() => self.changeSlide(1), 4000)
    },
    stopAutoPlay () {
      clearInterval(this.autoPlayInterval)
    }
  },
  watch: {
    imgs (x) {
      this.images = x.slice(0, 15)

      this.startAutoPlay()
      this.createDots()
      this.updateSlide()
    }
  },
  mounted () {
    let self = this

    // Keyboard Navigation
    document.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') self.changeSlide(-1)
      if (e.key === 'ArrowRight') self.changeSlide(1)
    })

    if (self.imgs) self.images = self.imgs.slice(0, 15)

    // Start auto-play
    self.startAutoPlay()

    // Pause auto-play on hover
    const galleryContainer = document.querySelector('.xgallery-container')
    galleryContainer.addEventListener('mouseenter', self.stopAutoPlay)
    galleryContainer.addEventListener('mouseleave', self.startAutoPlay)

    // Initialize Gallery
    self.createDots()
    self.updateSlide()
  }
}
</script>

<style lang="scss">
.xgallery-container{
  position: relative;
  width: 100%;
}
.xgallery-slider {
  position: relative;
  overflow: hidden;
}
#xgalleryImage {
  width: 100%;
  height: 420px;
  object-fit: cover;
  display: block;
  transition: opacity 0.5s ease;
}

.xdots-container {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 20px;
  padding: 10px;
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100%;
}
.xdot {
  width: 15px;
  height: 6px;
  background: #555;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 2px solid transparent;
  box-shadow:1px 1px 1px #aaa;
}
.xdot:hover {
  background: #888;
  transform: scale(1.2);
}
.xdot.active {
  background: #2b2a2a;
  border-color: #2b2a2a;
  transform: scale(1.3);
}

@media (max-width: 600px) {
  #xgalleryImage {
    height: 250px;
  }
  
  .xdot {
    width: 10px;
    height: 10px;
  }
}
</style>


// WEBPACK FOOTER //
// ImageSlider.vue?613e6ff9